
import {
  Avatar, Grid, IconButton, ListItem, ListItemAvatar, ListItemSecondaryAction, Typography,
} from "@mui/material";
import { ComboBox } from "@fas/ui-core";
import { Clear as ClearIcon } from "@mui/icons-material";

const rolesList = ["owner", "manager", "coder"];
const capitalize = (str: string = "") => str.toLowerCase()
  .split(" ")
  .map((s) => s.charAt(0).toUpperCase())
  .join("");

type Props = {
  user: {
    id: string,
    name: string,
    role?: string,
  },
  onChangeRole: (id: string, value: string) => void,
  onRemoveUser: (id: string) => void,
  isError?: boolean
}

function User({
  user, onChangeRole, onRemoveUser, isError = false,
}: Props) {
  const { id, name, role = null } = user;
  const handleChangeRole = (_: unknown, value: string): void => {
    onChangeRole(id, value);
  };
  const handleRemoveUser = () => {
    onRemoveUser(id);
  };
  return (
    <ListItem key={id}>
      <ListItemAvatar>
        <Avatar alt={name}>{capitalize(name)}</Avatar>
      </ListItemAvatar>
      <Grid container direction="row" width={1}>
        <Grid container size={9} alignItems="center">
          <Typography>{name}</Typography>
        </Grid>
        <Grid size={2}>
          <ComboBox
            label="Role"
            options={rolesList}
            value={role || ""}
            defaultValue={role || ""}
            onChange={handleChangeRole}
            disableClearable
            data-testid="user-roles"
            error={{
              isError,
              helperText: "Select role",
            }}
          />
        </Grid>
      </Grid>
      <ListItemSecondaryAction>
        {
          role && (
            role.toLowerCase() !== "owner" && (
              <IconButton onClick={handleRemoveUser} data-testid="users-list-remove-button">
                <ClearIcon />
              </IconButton>
            )
          )
        }
      </ListItemSecondaryAction>
    </ListItem>
  );
}

export default User;
